@if (idVendedor == null) {
<div class="equipe-neutra">
    Salve o cadastro para começar a montar a equipe deste vendedor.
</div>
} @else {

<div class="equipe-seletor">
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Selecione a equipe</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [formControl]="buscaControl" (focus)="dropdownAberto = true" (blur)="dropdownAberto = false">
    </mat-form-field>

    @if (dropdownAberto) {
    <div class="equipe-dropdown">
        @for (opcao of opcoesFiltradas; track opcao.idVendedor) {
        <button type="button" class="equipe-opcao" [class.indisponivel]="opcao.indisponivel"
            (mousedown)="$event.preventDefault(); selecionar(opcao)">
            <span class="equipe-opcao-nome">{{ opcao.nome }}</span>
            <span class="equipe-opcao-detalhe">{{ opcao.detalhe }}</span>
        </button>
        } @empty {
        <div class="equipe-opcao-vazia">Nenhum vendedor encontrado.</div>
        }
    </div>
    }
</div>

@if (membros.length === 0) {
<div class="equipe-nota">Nenhum subordinado vinculado a este vendedor.</div>
} @else {
<div class="equipe-chips">
    @for (idMembro of membros; track idMembro) {
    <span class="equipe-chip">
        {{ getNome(idMembro) }}
        @if (getQtdSubordinados(idMembro) > 0) {
        <span class="equipe-chip-contador">{{ getQtdSubordinados(idMembro) }}</span>
        }
        <mat-icon class="equipe-chip-remover" (click)="remover(idMembro)">close</mat-icon>
    </span>
    }
</div>
}

@if (historicoPendente.length > 0) {
<div class="equipe-historico">
    <div class="equipe-historico-titulo">Alterações a registrar no histórico</div>
    @for (linha of historicoPendente; track $index) {
    <div class="equipe-historico-linha">
        <mat-icon>{{ linha.icone }}</mat-icon>
        <span>{{ linha.texto }}</span>
    </div>
    }
</div>
}
}